import {GameVariant, ListVariant, MutableVariantMap, ValuesList, VariantData} from "./caos-def";
import {isObjectOfType} from "./utils.objects";
import {CaosLib} from "./utils.caosdef";

/**
 * Keeps track of keys for values lists needed by a variant
 */
const keysByVariant: MutableVariantMap<ValuesList[]> = {};

/**
 * Checks if object is a values list
 * @param item
 */
export function isValuesList(item: unknown): item is ValuesList {
    return isObjectOfType<ValuesList>(item, "id", "name", "arguments");
}

/**
 * Gets a list of values lists for a variant
 * @param caosLib CAOS definitions object, holding commands, values lists, etc.
 * @param variant use null of 'AL' for all values lists
 */
export function getValuesLists(caosLib: CaosLib, variant: ListVariant): ValuesList[] {
    const lists = caosLib.getValuesLists();
    if (!variant || variant === "AL") {
        return lists;
    }
    if (typeof keysByVariant[variant] !== "undefined") {
        return keysByVariant[variant]!;
    }

    const variantData: VariantData = caosLib.getVariantData(variant as GameVariant);
    const keys = variantData.values_lists_ids;
    const valuesLists: ValuesList[] = <ValuesList[]>keys
        .map(caosLib.getValuesList.bind(caosLib))
        .filter(list => list != null);
    keysByVariant[variant as GameVariant] = valuesLists
    return valuesLists;
}

